import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';

var _excluded = ["className", "children", "hasPictogram", "id", "targetHeaderId"];
// eslint-disable-next-line import/prefer-default-export
var AccordionContent = props => {
  var {
      className,
      children,
      hasPictogram,
      id,
      targetHeaderId
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  var ariaAttrs = {};
  // @ts-ignore
  ariaAttrs['aria-labelledby'] = targetHeaderId;
  ariaAttrs.role = 'region';
  var classNames$1 = classNames('accordion-content', className !== null && className !== void 0 ? className : className, {
    'withpictogram': hasPictogram
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classNames$1
  }, ariaAttrs, restProps), children);
};
AccordionContent.propTypes = {
  className: PropTypes.string,
  hasPictogram: PropTypes.bool,
  id: PropTypes.string.isRequired,
  targetHeaderId: PropTypes.string.isRequired
};
AccordionContent.defaultProps = {
  className: ''
};

export { AccordionContent };
